export const merchantEventTypes = {
  MERCHANT_CREATED: 'MERCHANT_CREATED',
  FIRST_ORDER: 'FIRST_ORDER',
  FIRST_CAPTURE: 'FIRST_CAPTURE',
  FIRST_PAYOUT: 'FIRST_PAYOUT',
  CAPTURE_ORIENTATION_DISMISSED: 'CAPTURE_ORIENTATION_DISMISSED',
  CAPTURE_ORIENTATION_EXPIRED: 'CAPTURE_ORIENTATION_EXPIRED',
  PAYOUTS_ENABLED: 'PAYOUTS_ENABLED'
}

export const userEventTypes = {
  SETTLEMENT_DOWNLOADED: 'SETTLEMENT_DOWNLOADED'
}

const allEventTypes = {
  ...merchantEventTypes,
  ...userEventTypes
}

export default allEventTypes
